if (!customElements.get('price-match-badges')) {
  customElements.define(
    'price-match-badges',
    class PriceMatchBadges extends HTMLElement {
      connectedCallback() {
        if (!this.installBadges()) queueMicrotask(() => this.installBadges());

        const productInfo = this.closest('product-info');
        if (!productInfo || this.badgeObserver) return;

        this.badgeObserver = new MutationObserver(() => this.installBadges());
        this.badgeObserver.observe(productInfo, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.badgeObserver?.disconnect();
        this.badgeObserver = null;
      }

      installBadges() {
        const productInfo = this.closest('product-info');
        this.badgeElement ||= this.querySelector('[data-price-match-trigger]');
        const badge = this.badgeElement;

        if (!productInfo || !badge) return false;

        const container = productInfo.querySelector(
          '.product__info-wrapper .product__price-row',
        );

        if (container && badge.parentElement !== container) {
          container.append(badge);
        }

        this.openResponse(productInfo, badge);
        return Boolean(container);
      }

      openResponse(productInfo, badge) {
        const response = productInfo.querySelector('[data-price-match-response]');

        if (!response || !badge || this.dataset.responseOpened) return;

        this.dataset.responseOpened = 'true';
        queueMicrotask(() => badge.click());
      }
    },
  );
}
